import { render, staticRenderFns } from "./AccordionContainer.vue?vue&type=template&id=4e512f9b&scoped=true&"
import script from "./AccordionContainer.vue?vue&type=script&lang=js&"
export * from "./AccordionContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e512f9b",
  null
  
)

export default component.exports